import Section from '../Section';
import QuickAdd from '../global/QuickAdd';

export default class FeaturedCollection extends Section {
  /**
   * @param {import('../ThemeBase').default} theme
   * @param {HTMLElement} element
   * @param {boolean} pageLoad
   */

  constructor(theme, element, pageLoad) {
    super(theme, element, pageLoad);

    this.quickAddButtons = new QuickAdd(theme, element);
    this.theme.addBadges(this.element, 1000);
  }

  // check if we're on mobile
  isMobile = () => {
    return window.matchMedia('(max-width: 1023px)').matches;
  }
}
